// extracted by mini-css-extract-plugin
export var ratingAppStore = "_6COGH";
export var ratingPlayStore = "aUpYZ";